/**
 * Walmart Impact affiliate URL builder (parity with ecom-redirect / yoto-web).
 */

const IMPACT_BASE = 'https://goto.walmart.com/c/10621/565706/9383';

export function isWalmartUrl(href: string): boolean {
  try {
    const host = new URL(href, typeof location !== 'undefined' ? location.href : undefined)
      .hostname
      .replace(/^www\./i, '')
      .toLowerCase();
    return host === 'walmart.com' || host.endsWith('.walmart.com');
  } catch {
    return /walmart\.com/i.test(href);
  }
}

export interface WalmartImpactUrlOptions {
  destinationUrl: string;
  sessionId: string;
  mbid?: string;
  websiteDomain: string;
}

export interface WalmartImpactUrlResult {
  url: string;
  /** `subId1_subId2` — maps to `/dye` `ecsid`. */
  clickId: string;
  /** Destination Walmart URL (`u=`). */
  destinationUrl: string;
}

export function buildWalmartImpactUrl(opts: WalmartImpactUrlOptions): WalmartImpactUrlResult {
  const subId1 = `kzu_${opts.sessionId || '0'}`;
  const subId2 = `kzu_${opts.mbid || '0'}`;
  const sharedid = `kzu_${opts.websiteDomain || 'unknown'}`;
  const url = new URL(IMPACT_BASE);
  url.searchParams.set('subId1', subId1);
  url.searchParams.set('subId2', subId2);
  url.searchParams.set('sharedid', sharedid);
  url.searchParams.set('veh', 'aff');
  url.searchParams.set('sourceid', 'imp_000011112222333344');
  url.searchParams.set('u', opts.destinationUrl);
  return {
    url: url.toString(),
    clickId: `${subId1}_${subId2}`,
    destinationUrl: opts.destinationUrl,
  };
}

/** True when the href is already an Impact goto.walmart.com affiliate link. */
export function isWalmartImpactUrl(href: string): boolean {
  try {
    const url = new URL(href, typeof location !== 'undefined' ? location.href : undefined);
    return url.hostname.toLowerCase().includes('goto.walmart.com');
  } catch {
    return /goto\.walmart\.com/i.test(href);
  }
}

export function destinationFromImpactUrl(href: string): string | null {
  try {
    return new URL(href).searchParams.get('u');
  } catch {
    return null;
  }
}
